<div class="flowchart-container" [ngClass]="getDecisionTreeClass()">
  @switch (imageKey) {
    @case ("sellout-novilc-v2") {
      <img
        src="assets/images/simulation-decision-trees/decision-tree-simulation-with-sellout-and-no-vilc-ref-V2.svg"
        alt="SKU Flowchart"
        class="background-image"
      />
    }
    @case ("sellout-novilc-v3") {
      <img
        src="assets/images/simulation-decision-trees/decision-tree-simulation-with-sellout-and-no-vilc-ref-V3.png"
        alt="SKU Flowchart"
        class="background-image"
      />
    }
    @case ("nosellout-novilc-v2") {
      <object
        type="image/svg+xml"
        data="assets/images/simulation-decision-trees/decision-tree-simulation-without-sellout-and-no-vilc-ref-V2.svg"
        class="background-image"
      ></object>
    }
    @case ("nosellout-novilc-v3") {
      <img
        src="assets/images/simulation-decision-trees/decision-tree-simulation-without-sellout-and-no-vilc-ref-V3.png?q=1"
        alt="SKU Flowchart"
        class="background-image"
      />
    }
    @case ("sellout-vilc-v2") {
      <img
        src="assets/images/simulation-decision-trees/decision-tree-simulation-with-sellout-and-with-vilc-ref-V2.png"
        alt="SKU Flowchart"
        class="background-image"
      />
    }
    @case ("sellout-vilc-v3") {
      <img
        src="assets/images/simulation-decision-trees/decision-tree-simulation-with-sellout-and-with-vilc-ref-V3.png"
        alt="SKU Flowchart"
        class="background-image"
      />
    }
    @case ("nosellout-vilc-v2") {
      <img
        src="assets/images/simulation-decision-trees/decision-tree-simulation-without-sellout-and-with-vilc-ref-V2.png"
        alt="SKU Flowchart"
        class="background-image"
      />
    }
    @case ("nosellout-vilc-v3") {
      <img
        src="assets/images/simulation-decision-trees/decision-tree-simulation-without-sellout-and-with-vilc-ref-V3.png"
        alt="SKU Flowchart"
        class="background-image"
      />
    }
    @case ("ytd-sellout-novilc-v3") {
      <img
        src="assets/images/simulation-decision-trees/ytd-decision-tree-simulation-with-sellout-and-no-vilc-ref-V3.png"
        alt="SKU Flowchart"
        class="background-image"
      />
    }
    @case ("ytd-nosellout-novilc-v3") {
      <img
        src="assets/images/simulation-decision-trees/ytd-decision-tree-simulation-without-sellout-and-no-vilc-ref-V3.png"
        alt="SKU Flowchart"
        class="background-image"
      />
    }
    @case ("ytd-sellout-vilc-v3") {
      <img
        src="assets/images/simulation-decision-trees/ytd-decision-tree-simulation-with-sellout-and-with-vilc-ref-V3.png"
        alt="SKU Flowchart"
        class="background-image"
      />
    }
    @case ("ytd-nosellout-vilc-v3") {
      <img
        src="assets/images/simulation-decision-trees/ytd-decision-tree-simulation-without-sellout-and-with-vilc-ref-V3.png"
        alt="SKU Flowchart"
        class="background-image"
      />
    }
  }

  @for (pos of positions; track pos.class) {
    <div>
      @if (values?.[pos.key] !== null) {
        <div
          [class]="
            'overlay ' +
            (pos.type === 'output' ? 'output-text' : 'bold-text') +
            ' ' +
            pos.class
          "
        >
          {{ values[pos.key] }}
        </div>
      }
    </div>
  }

  @if (!hasSellout) {
    <img
      src="assets/images/caution-icon.svg"
      alt="Warning"
      [ngClass]="warningIconClass"
      matTooltip="Financial Recovery Test is not applicable in Without Sellout flow"
      matTooltipPosition="below"
    />
  }
</div>

@if (values?.overall_decision_tree) {
  <div class="instruction-box">
    <p>The decision tree above is calculated based on the overall result.</p>
  </div>
}
